module.exports = __webpack_public_path__ + "static/media/ic-notif-claim.29fdd75c.svg";